<div class="grid mt-2 ml-3 overview-details mr-0">
    <div class="col-6 md:col-12 lg:col-6 pl-0 pt-0 pr-3">

        <div class="card p-fluid">
            <div class="flex justify-content-between flex-wrap">
                <div class="flex justify-content-center mb-3">
                    <label class="card-heading category-name" translate>sponsor.lbl_sponsor_details</label>
                </div>
                <div class="edit justify-content-center mb-3 cursor-pointer" [ngClass]="{'hidden': isDeleted}"
                    (click)="redirectToEdit()">
                    <label class="card-action" translate>sponsor.lbl_edit</label>
                    <i class="mi-lg edit_pencil"></i>
                </div>
            </div>
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading"
                        translate>{{cs.getLabelValue('sponsor.fields.sponsor_status.label',attributeLabels,'sponsor.lbl_status')}}</label>
                </div>
                <div class="col-8  pb-1">
                    @if (sponsorStatus) {
                    @for (item of sponsorStatus | keyvalue; track item.key) {
                    <span class="status-dot" [ngClass]="{
                            'bg-green-500':item.value ?.toLowerCase() === 'active',
                            'bg-red-500': item.value ?.toLowerCase() === 'inactive'}">
                    </span> {{ item.value ? item.value : '--'}}
                    }
                    } @else {
                    --
                    }
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading"
                        translate>{{cs.getLabelValue('sponsor.fields.sponsor_code.label',attributeLabels,'sponsor.lbl_id')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{sponsorCode || '--'}}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading"
                        translate>{{cs.getLabelValue('sponsor.fields.sponsor_name.label',attributeLabels,'sponsor.lbl_full_legal_name')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{sponsorName || '--'}}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading"
                        translate>{{cs.getLabelValue('sponsor.fields.myob_customer_id.label',attributeLabels,'')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{myObCustomerId || '--'}}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading"
                        translate>{{cs.getLabelValue('sponsor.groups.sponsor_address.label',attributeLabels,'sponsor.lbl_postal_address')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{sponsorAddress || '--'}}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading"
                        translate>{{cs.getLabelValue('sponsor.fields.contact_number.label',attributeLabels,'sponsor.lbl_phone_number')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{sponsorPhone || '--'}}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading"
                        translate>{{cs.getLabelValue('sponsor.fields.email.label',attributeLabels,'sponsor.lbl_email_address')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{sponsorEmail || '--'}}</label>
                </div>
            </div>
        </div>
    </div>

    <div class="col-6 md:col-12 lg:col-6 pl-0 pt-0 pr-3">

        <div class="card p-fluid">
            <div class="flex justify-content-between flex-wrap">
                <div class="flex justify-content-center mb-3">
                    <label class="card-heading category-name" translate>sponsor.lbl_billing_details</label>
                </div>
                <div class="edit justify-content-center mb-3 cursor-pointer" [ngClass]="{'hidden': isDeleted}"
                    (click)="redirectToEdit()">
                    <label class="card-action" translate>sponsor.lbl_edit</label>
                    <i class="mi-lg edit_pencil"></i>
                </div>
            </div>
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading"
                        translate>{{cs.getLabelValue('sponsor.fields.billing_entity.label',attributeLabels,'sponsor.lbl_billing_entity')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{ billingEntity || '--'}}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading"
                        translate>{{cs.getLabelValue('sponsor.fields.abn_number.label',attributeLabels,'sponsor.lbl_abn_number')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{abnNumber || '--'}}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading"
                        translate>{{cs.getLabelValue('sponsor.fields.account_number.label',attributeLabels,'account_number')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{accountNumber || '--'}}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading"
                        translate>{{cs.getLabelValue('sponsor.fields.acc_contact_name.label',attributeLabels,'acc_contact_name')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{accContactName || '--'}}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading"
                        translate>{{cs.getLabelValue('sponsor.fields.acc_contact_email.label',attributeLabels,'acc_contact_email')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{accContactEmail || '--'}}</label>
                </div>
            </div>
        </div>
    </div>
</div>